if (!customElements.get('popup-dialog')) {
  class PopupDialog extends HTMLElement {
    constructor() {
      super();
      // Config from dataset
      this.delay = Number(this.dataset.delay) * 1000; // ms
      this.expiration = Number(this.dataset.expiration) * 24; // hours
      this.isChallengePage = window.location.toString().includes('/challenge');
      this.closeButton = this.querySelector('[id^="ModalClose-"]');
      this._hideHandler = this.hide.bind(this);
      this._escHandler = (event) => {
        if (event.code.toUpperCase() === 'ESCAPE') this.hide();
      };
    }

    connectedCallback() {
      // console.log('connectedCallback');
      if (this._initialized) return;
      this._initialized = true;
      // Move to body if not already
      if (!this.parentNode || this.parentNode.nodeName !== 'BODY') {
        document.body.appendChild(this);
      }
      // Event listeners
      if (this.closeButton) {
        this.closeButton.addEventListener('click', this._hideHandler);
      }
      this.addEventListener('keyup', this._escHandler);
      // Consent tracking
      this.loadConsentTrackingApi();
      // Show/hide logic
      this.determineReveal();
    }

    disconnectedCallback() {
      // console.log('disconnectedCallback');
      if (this.closeButton) {
        this.closeButton.removeEventListener('click', this._hideHandler);
      }
      this.removeEventListener('keyup', this._escHandler);
      this.removeEventListener('click', this._backdropHandler);
    }

    loadConsentTrackingApi() {
      // console.log('loadConsentTrackingApi');
      if (!window.Shopify || !window.Shopify.loadFeatures) return;
      window.Shopify.loadFeatures([
        { name: 'consent-tracking-api', version: '0.1' }
      ], function (error) {
        if (error) throw error;
      });
    }

    determineReveal() {
      // console.log('determineReveal');
      if (this.isChallengePage) return;
      if (window.localStorage) {
        let nextPopup = localStorage.getItem(`${this.id}`);
        if (nextPopup && nextPopup > new Date()) return;
      }
      setTimeout(() => this.show(), this.delay);
    }

    canUseStorage() {
      // console.log('canUseStorage');
      return (
        !window.Shopify?.customerPrivacy ||
        window.Shopify.customerPrivacy.userCanBeTracked()
      );
    }

    setExpiration() {
      // console.log('setExpiration');
      // console.log(this.canUseStorage());
      if (!this.canUseStorage()) return;
      if (window.localStorage) {
        let expirationDate = new Date();
        expirationDate = expirationDate.setHours(expirationDate.getHours() + this.expiration);
        // console.log(`Setting expiration for ${this.id}`);
        localStorage.setItem(`${this.id}`, expirationDate);
      }
    }

    show() {
      // console.log('show');
      this.setAttribute('open', '');
      document.body.classList.add('overflow-hidden');
      document.body.dispatchEvent(new CustomEvent('modalOpened'));
      trapFocus(this, this.querySelector('[role="dialog"]'));
    }

    hide() {
      // console.log('hide');
      document.body.classList.remove('overflow-hidden');
      document.body.dispatchEvent(new CustomEvent('modalClosed'));
      this.removeAttribute('open');
      //removeTrapFocus(this.openedBy);
      this.setExpiration();
    }

  }
  customElements.define('popup-dialog', PopupDialog);
}
